import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';

import { CustomTheme } from './theme';

const {
	default: styled,
	css,
	ThemeProvider,
	createGlobalStyle
} = styledComponents as Pick<
	ThemedStyledComponentsModule<CustomTheme>,
	'default' | 'css' | 'createGlobalStyle' | 'keyframes' | 'ThemeProvider' | 'ThemeContext'
>;

export { css, createGlobalStyle };

export default styled;
